module.exports = __webpack_public_path__ + "img/kyano-card-illustration-people.4612a202.svg";